export type MetricKey =
  | "schedule"
  | "budget"
  | "quality"
  | "teamTrust"
  | "stakeholderTrust"
  | "technicalDebt"
  | "operationalRisk";

export const METRIC_KEYS: MetricKey[] = [
  "schedule",
  "budget",
  "quality",
  "teamTrust",
  "stakeholderTrust",
  "technicalDebt",
  "operationalRisk",
];

/** Higher is worse for these two — everything else, higher is better. */
export const INVERTED_METRICS: MetricKey[] = ["technicalDebt", "operationalRisk"];

export interface ProjectMetrics {
  schedule: number;
  budget: number;
  quality: number;
  teamTrust: number;
  stakeholderTrust: number;
  technicalDebt: number;
  operationalRisk: number;
}

export interface ProjectState extends ProjectMetrics {
  day: number;
  activeEventIds: string[];
  resolvedEventIds: string[];
  pendingEvents: FutureEvent[];
  history: DecisionRecord[];
}

export interface Effect {
  metric: MetricKey;
  delta: number;
}

/** A consequence scheduled for a later day — the piece a linear scene chain can't express. */
export interface FutureEvent {
  eventId: string;
  eligibleOnDay: number;
}

export interface Choice {
  id: string;
  text: string;
  description?: string;
  effects: Effect[];
  resultText: string;
  schedules?: FutureEvent[];
}

export interface ProjectEvent {
  id: string;
  title: string;
  sender: string;
  day: string;
  body: string[];
  /** Conditional eligibility — day thresholds AND metric thresholds, not just a fixed slot. */
  eligibleWhen: (state: ProjectState) => boolean;
  choices: Choice[];
}

export interface ProjectOutcome {
  id: string;
  label: string;
  when: (state: ProjectState) => boolean;
  summary: string;
}

export interface Scenario {
  id: string;
  title: string;
  premise: string[];
  initialMetrics: ProjectMetrics;
  events: ProjectEvent[];
  outcomes: ProjectOutcome[];
  endWhen: (state: ProjectState) => boolean;
}

export interface DecisionRecord {
  day: number;
  eventId: string;
  eventTitle: string;
  choiceId: string;
  choiceText: string;
  effects: Effect[];
  resultText: string;
}
